import { render } from "./SurveyPage11.vue?vue&type=template&id=5f3db7a5&scoped=true"
const script = {}

import "./SurveyPage11.vue?vue&type=style&index=0&id=5f3db7a5&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f3db7a5"]])

export default __exports__